import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UsuarioEsquema } from '../../usuarioEsquema';
import { Usuario } from '../../usuario';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';
import { DatePipe } from '@angular/common';
@Injectable({
  providedIn: 'root'
})
export class SegtrncompilarpaquetesService {
  public way: string;
  constructor(private http: HttpClient,
    public usuarioEsquema: UsuarioEsquema,
    public usuario: Usuario, private datePipe: DatePipe,
    private init: NuevoComponentService,
    private confIniciales: ConfInicialesService) {
    this.way = sessionStorage.getItem('way');
  }

  procesarpaquete(tipo,nombre): Promise<any[]> {

    return this.http.post<any>(this.way + '/seg/compilarbase/662d99555bdba0000000', {
      elementos: {
        strtipo: tipo,
        name: nombre,

      }
    }, this.confIniciales.httpOptions()).toPromise();

  }
  consultarpaquetes(tipo): Promise<any[]> {

    return this.http.post<any>(this.way + '/seg/compilarbase/662fcf57aadedc00000000000', {
      elementos: {
        strtipo: tipo,

      }
    }, this.confIniciales.httpOptions()).toPromise();

  }
 
}
